import { FC, ReactNode, useState } from 'react'
import {
  AppBar as MuiAppBar,
  Box,
  IconButton,
  Typography,
  Toolbar,
  styled,
  Avatar,
} from '@mui/material'
import { Menu as MenuIcon } from '@mui/icons-material'
import { useLocation } from 'react-router-dom'
import { routes } from '@/routes/index'
import { Drawer, NotificationPopover } from '@/components/index'
// import { Credentials } from '@/pages'
import theme from '@/utilities/Theme'

const AppBarContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row-reverse',
  alignItems: 'center',
  gap: '20px',
})

const ProfileContainer = styled(Box)({
  alignItems: 'center',
  flexDirection: 'row-reverse',
  display: 'flex',
  gap: '50px',
})

const ProfileAvatar = styled(Avatar)({
  width: 40,
  height: 40,
  backgroundColor: '#E0E0E0',
  color: '#FFF',
  cursor: 'pointer',
  fontSize: '16px',
  fontWeight: 'bold',
  borderRadius: '12px',
  '&:hover': {
    backgroundColor: '#D0D0D0',
  },
  [theme.breakpoints.down('sm')]: {
    width: 30,
    height: 30,
    fontSize: '14px',
    borderRadius: '8px',
  },
})

const AppBarProfileName = styled(Typography)({
  color: '#00261C',
  fontWeight: '400',
  fontSize: '16px',
  fontFamily: 'Gabarito',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
})

const drawerWidth = 300

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open: boolean }>(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100vw - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginLeft: 0,
    },
  }),
  height: '60px',
  overflow: 'hidden',
  boxShadow: 'none',
  background: '#FFFFFF',
  fontWeight: 700,
  fontFamily: 'Gabarito',
}))

// const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
//   open?: boolean
// }>(({ theme, open }) => ({
//   marginTop: '60px',
//   height: `calc(100vh - 60px)`,
//   width: open ? `calc(110vw - ${drawerWidth}px)` : '84vw',
//   flexGrow: 1,
//   transition: theme.transitions.create('margin', {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     transition: theme.transitions.create('margin', {
//       easing: theme.transitions.easing.easeOut,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//     marginLeft: 0,
//   }),
//   padding: '0.5% 1% 0 1%',
//   background: 'url("/back.png")',
//   backgroundSize: 'cover',
//   backgroundColor: '#EFF3FD',
// }))

const Main = styled('main', {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open: boolean }>(({ theme, open }) => ({
  marginTop: '60px',
  height: `calc(100vh - 60px)`,
  width: open ? `calc(100vw - ${drawerWidth}px)` : '100vw',
  flexGrow: 1,
  padding: '0.5% 1% 0 1%',
  background: 'url("/back.png")',
  backgroundSize: 'cover',
  backgroundColor: '#EFF3FD',
  transition: 'width 0.3s ease',
  overflowY: 'auto',
  overflowX: 'hidden',
  [theme.breakpoints.down('md')]: {
    width: '100vw',
  },
}))

// const Main = styled('main')({
//   marginTop: '60px',
//   height: `calc(100vh - 60px)`,
//   width: '100vw',

//   flexGrow: 1,
//   padding: '0.5% 1% 0 1%',
//   background: 'url("/back.png")',
//   backgroundSize: 'cover',
//   backgroundColor: '#EFF3FD',
// })

const AppBarTitleText = styled(Typography)({
  color: '#00261C',
  fontWeight: 700,
  fontSize: '19px',
  fontFamily: 'Gabarito',
  [theme.breakpoints.down('sm')]:{
    fontSize: '17px'
  }
})

const CustomToolBar = styled(Toolbar)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

interface MainViewProps {
  children: ReactNode
}

export const MainView: FC<MainViewProps> = ({ children }) => {
  const [open, setOpen] = useState(false)
  const location = useLocation()

  const toggleDrawer = () => setOpen(!open)

  const currentRoute = routes.find((route) => route.path === location.pathname)

  const handleProfileClick = () => {
    console.log('Profile clicked')
  }

  function stringToColor(string: string) {
    let hash = 0
    let i

    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash)
    }

    let color = '#'

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff
      color += `00${value.toString(16)}`.slice(-2)
    }

    return color
  }

  function stringAvatar(name: string) {
    if (!name) return { sx: {}, children: '' }

    const splitName = name.split(' ')
    const firstLetter = splitName[0][0]
    const secondLetter = splitName[1]?.[0] || ''

    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${firstLetter}${secondLetter}`,
    }
  }

  // {!isProd && (
  //   <Route path="/credentials" element={<Credentials />} />
  // )}

  

  console.log('current route ', currentRoute)

  return (
    <Box sx={{ display: 'flex' }}>
      <Drawer open={open} onClose={toggleDrawer} />

      {/* AppBar */}
      <AppBar open={open}>
        <CustomToolBar>
          <AppBarContainer>
            <AppBarTitleText variant="h6">
              {currentRoute ? currentRoute.name : 'AppBar Title'}
            </AppBarTitleText>
            <IconButton edge="start" aria-label="menu" onClick={toggleDrawer}>
              <MenuIcon />
            </IconButton>
          </AppBarContainer>
          <AppBarContainer>
            <ProfileContainer>
              <ProfileAvatar
                onClick={handleProfileClick}
                {...stringAvatar(localStorage.getItem('name') ?? '')}
              />
              <AppBarProfileName>
                {localStorage.getItem('name')}
              </AppBarProfileName>
            </ProfileContainer>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <NotificationPopover />
            </Box>
          </AppBarContainer>
        </CustomToolBar>
      </AppBar>

      {/* Main Content */}
      <Main open={open}>{children}</Main>
    </Box>
  )
}
